var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGyAsy6IconsCmykHandlingWhtPrintAw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICONS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.1 170.1",
    style: {
      enableBackground: "new 0 0 170.1 170.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,68.4c1.2,0.3,2.9,1.1,4,0.4c2.1-1.4-0.9-4.9-1.8-6.2c-4-5.6-8-11.7-11.6-16.6c0-0.1,0-0.2-0.1-0.1 c-3.1,4.3-7.3,10.8-11,16c-1.1,1.6-3.5,3.9-3.2,5.7c0.3,2.4,3.1,1.3,4.9,0.9c1.5-0.4,2.6-0.7,4-0.9c-0.5,7.8,3,12.6,8.1,15 c2.4,1.1,5.4,1.4,5.8,3.5c0.8,4.3-3.8,4-6.6,4.8c-6.1,1.8-11,5.7-11.5,12.9c-0.3,4.9,2,9.1,4.4,11.5c1.4,1.4,3.8,2,4.4,4.1 c0.4,1.5-0.1,2.5,0.1,4.9c3.6,0,7.1,0,10.7,0c0.3-6.1-0.3-10.7-3.5-13.9c-1.6-1.6-5.4-2.9-5-6.2c0.4-3.4,6.9-3.4,9.7-4.8 c3.8-1.9,7.7-6.3,8-12.4c0.3-6.8-4.2-11.4-8.9-13.2c-1.7-0.6-3.8-0.7-4.6-2.5c-0.4-0.9-0.5-2.4-0.3-3.7C89.3,67.8,90.5,68.1,92,68.4 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85,158.7c-40.6,0-73.7-33.1-73.7-73.7S44.4,11.3,85,11.3s73.7,33.1,73.7,73.7S125.7,158.7,85,158.7z M85,22.4 c-34.5,0-62.6,28.1-62.6,62.6s28.1,62.6,62.6,62.6s62.6-28.1,62.6-62.6C147.7,50.5,119.6,22.4,85,22.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGyAsy6IconsCmykHandlingWhtPrintAw);
export default __webpack_public_path__ + "static/media/GY_ASY6_ICONS_CMYK_HANDLING_WHT_PRINT_AW.e613049fe4fe4a23f4f725940d02e893.svg";
export { ForwardRef as ReactComponent };